import { Controller, useFormContext } from 'react-hook-form';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import { ClaimFormState } from '../../../../models/rewards/calor/ClaimForm';
import HyperDatepicker from '../../../common/Datepicker';
import CalorCashbackPeriod from '../../../../models/rewards/calor/CalorCashbackPeriod';
import ApiResource from '../../../ApiResource';
const Today = new Date();

type PeriodWrapperProps = {
    resource: string,
    children: (period: CalorCashbackPeriod | null) => React.ReactElement,
}

const PeriodWrapper = ({resource, children}: PeriodWrapperProps) => (
    <ApiResource resource={resource}
        renderError={(error, defaultRender) => error.status === 404 ? children(null) : defaultRender(error)}
    >
        {(period: CalorCashbackPeriod) => children(period)}
    </ApiResource>
)
//23/09/2025 - 28/02/2026
const formatDate = (date: string): string => {
  const d = new Date(date);
  return d.toLocaleDateString("en-GB"); 
};
const PurchaseDateGroup = (): JSX.Element => {
    const {formState: {errors}} = useFormContext<ClaimFormState>();
    return (
        <PeriodWrapper resource='/calor/periods/active'>
            {(activePeriod: CalorCashbackPeriod) => (
            <FormGroup>
                <Label for='purchase-date' className='mb-0'>Date on your receipt:</Label>
                <p>Your receipts need to be uploaded within the current period:
                    <span style={{ color: "red" }}>
                        {" "}{formatDate(activePeriod.startDate)} - {formatDate(activePeriod.endDate)}.{" "}
                    </span> 
                    If you upload a receipt outside these dates, it will be rejected and won't count towards your cashback.</p>

                <Row>
                    <Col md={8} lg={6} xl={4}>
                        <Controller
                            name='purchaseDate'
                            render={({field: {ref, value, onChange, ...rest}}) => (
                                <HyperDatepicker
                                    id='purchase-date'
                                    maxDate={Today}
                                    placeholderText='00/00/0000'
                                    isInvalid={errors.purchaseDate !== undefined}
                                    selected={value}
                                    onChange={newDate => onChange(newDate)}
                                    hideAddon
                                    {...rest}/>
                            )}
                            rules={{required: true}}/>
                    </Col>
                </Row>

                {errors.purchaseDate && <span className='d-block text-danger'>Purchase date required</span>}
            </FormGroup>
        )}
        </PeriodWrapper>

    );
}

export default PurchaseDateGroup;

